<template>
  <div v-if="meta && meta.total > 0" class="flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 px-3 pt-4 text-sm text-slate-500 dark:border-slate-700 dark:text-slate-400">
    <div class="flex items-center gap-3">
      <span>{{ meta.from }}–{{ meta.to }} sur {{ meta.total }}</span>
      <label class="flex items-center gap-2">
        <span class="sr-only">Éléments par page</span>
        <select class="rounded-lg border border-slate-200 bg-white px-2 py-1 text-xs focus:border-cyan-500 focus:outline-none dark:border-slate-600 dark:bg-slate-800" :value="meta.per_page" @change="$emit('update:perPage', Number($event.target.value))">
          <option v-for="n in [10, 25, 50, 100]" :key="n" :value="n">{{ n }} / page</option>
        </select>
      </label>
    </div>
    <nav v-if="meta.last_page > 1" class="flex items-center gap-1" aria-label="Pagination">
      <button type="button" class="btn-icon" :disabled="meta.current_page <= 1" aria-label="Page précédente" @click="$emit('update:page', meta.current_page - 1)">
        <AppIcon name="chevron-left" />
      </button>
      <template v-for="p in pages" :key="p.key">
        <span v-if="p.gap" class="px-1 text-slate-400">…</span>
        <button
          v-else
          type="button"
          class="h-8 min-w-[2rem] rounded-lg px-2 text-xs font-semibold transition-colors"
          :class="p.n === meta.current_page ? 'bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900' : 'text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-700'"
          :aria-current="p.n === meta.current_page ? 'page' : undefined"
          @click="$emit('update:page', p.n)"
        >
          {{ p.n }}
        </button>
      </template>
      <button type="button" class="btn-icon" :disabled="meta.current_page >= meta.last_page" aria-label="Page suivante" @click="$emit('update:page', meta.current_page + 1)">
        <AppIcon name="chevron-right" />
      </button>
    </nav>
  </div>
</template>

<script>
import AppIcon from './AppIcon.vue'

export default {
  name: 'AppPagination',
  components: { AppIcon },
  props: { meta: { type: Object, default: null } },
  emits: ['update:page', 'update:perPage'],
  computed: {
    pages() {
      const { current_page: current, last_page: last } = this.meta
      const numbers = new Set([1, last, current - 1, current, current + 1])
      const sorted = [...numbers].filter((n) => n >= 1 && n <= last).sort((a, b) => a - b)
      const out = []
      sorted.forEach((n, i) => {
        if (i > 0 && n - sorted[i - 1] > 1) out.push({ key: `gap${n}`, gap: true })
        out.push({ key: n, n })
      })
      return out
    }
  }
}
</script>
